import { Arrow } from './Arrow';
import classNames from 'classnames';
import React, { memo } from 'react';
import styles from './MoneyReceivalTimeFrame.module.scss';

export interface IdentityVerificationTemplateProps {
  className?: string;
  content?: {
    prefix1?: string;
  };
}

export default memo(function MoneyReceivalTimeFrame({
  className,
  content = { prefix1: '' },
}: IdentityVerificationTemplateProps) {
  return (
    <div className={classNames(styles.container, className)}>
      {/** From */}
      <div className={styles['wrapper-left']}>
        <div className={styles.content}>
          <span className={styles.prefix}>{content.prefix1}</span>
          <span className={styles.central}>15</span>
          <span className={styles.suffix}>min.</span>
        </div>
      </div>
      <div className={styles.arrow}>
        <Arrow viewBox="0 0 50 80" />
      </div>
      {/** To */}
      <div className={styles['wrapper-right']}>
        <div className={styles.content}>
          <span className={styles.prefix}>a</span>
          <span className={styles.central}>48</span>
          <span className={styles.suffix}>h.</span>
        </div>
      </div>
    </div>
  );
});
